import styled from "styled-components";

export const StyledDatePicker = styled("div")`
  min-width: 5rem;
`;